import { render, staticRenderFns } from "./FaqCategoryForm.vue?vue&type=template&id=c8f43352"
import script from "./FaqCategoryForm.vue?vue&type=script&lang=js"
export * from "./FaqCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports